import { render, staticRenderFns } from "./GroupIcon.vue?vue&type=template&id=3334544c&scoped=true&"
import script from "./GroupIcon.vue?vue&type=script&lang=js&"
export * from "./GroupIcon.vue?vue&type=script&lang=js&"
import style0 from "./GroupIcon.vue?vue&type=style&index=0&id=3334544c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334544c",
  null
  
)

export default component.exports